const name = 'module/prom-ua';

export const GET_MODULE_CONFIGURATION_REQUEST = `${name}/GET_MODULES_CONFIGURATION_REQUEST`;
export const GET_MODULE_CONFIGURATION_SUCCESS = `${name}/GET_MODULES_CONFIGURATION_SUCCESS`;
export const GET_MODULE_CONFIGURATION_FAILURE = `${name}/GET_MODULES_CONFIGURATION_FAILURE`;

export const UPDATE_MODULE_CONFIGURATION_REQUEST = `${name}/UPDATE_MODULES_CONFIGURATION_REQUEST`;
export const UPDATE_MODULE_CONFIGURATION_SUCCESS = `${name}/UPDATE_MODULES_CONFIGURATION_SUCCESS`;
export const UPDATE_MODULE_CONFIGURATION_FAILURE = `${name}/UPDATE_MODULES_CONFIGURATION_FAILURE`;

export const TOGGLE_CONFIGURATION_STATUS_REQUEST = `${name}/TOGGLE_CONFIGURATION_STATUS_REQUEST`;
export const TOGGLE_CONFIGURATION_STATUS_SUCCESS = `${name}/TOGGLE_CONFIGURATION_STATUS_SUCCESS`;
export const TOGGLE_CONFIGURATION_STATUS_FAILURE = `${name}/TOGGLE_CONFIGURATION_STATUS_FAILURE`;

export default name;
